import BaseAuthController from "@rmp/core/api/base/baseAuthController";
import AbortService from "@rmp/core/services/abortService";

export class AuthController extends BaseAuthController {
	constructor(abortService: AbortService) {
		super(abortService);
	}
	
	signInWithProfile = this.api.connect.signInWithProfileCreate;
}
